import tw from "twin.macro"
import Head from "next/head"

import useMap from "lib/useMap"
import Container from "components/Container"
import { MapPinIconString } from "icons/MapPin"
import { MapCProps } from "components/dynamic"

import { generatePopupHTML } from "./popup"
import { MapAContainer } from "./styles"

const MapC = ({
  Longitude = 125.3252,
  Latitude = -17.6432,
  Overlay,
  Zoom,
  PointOfInterest = [],
  ShowStartMarker = true,
  ShowEndMarker = true,
}: MapCProps) => {
  const onInit = (map, mapboxgl) => {
    const coords = Overlay?.features?.[0]?.geometry?.coordinates || [
      Longitude,
      Latitude,
    ]
    const [firstPoint] = coords
    const lastPoint = coords[coords.length - 1]
    const textLayerStyles = {
      "text-size": 14,
      "text-transform": "uppercase",
      "text-font": [
        "Montserrat Bold",
        "Open Sans Regular",
        "Arial Unicode MS Regular",
      ],
      "text-letter-spacing": 1 / 14,
      "text-offset": [0, -4],
    }

    PointOfInterest.forEach((Pin) => {
      new mapboxgl.Popup({
        maxWidth: "90%",
        closeOnClick: false,
        closeButton: false,
      })
        .setHTML(
          generatePopupHTML({
            region: {
              Name: Pin.Name,
            },
            Name: Pin.Content,
            Hero: {
              BackgroundImage: Pin.Image,
            },
          })
        )
        .setLngLat([Pin.Longitude, Pin.Latitude])
        .addTo(map)
    })
    if (!Overlay) {
      return
    }
    map.on("load", () => {
      map.addSource("overlay", {
        type: "geojson",
        data: Overlay,
      })
      if (ShowStartMarker) {
        map.addSource("start", {
          type: "geojson",
          data: {
            type: "Point",
            coordinates: firstPoint,
          },
        })
        map.addLayer({
          id: "start",
          source: "start",
          type: "symbol",
          layout: {
            "text-field": "Start",
            ...textLayerStyles,
          },
        })
      }
      if (ShowEndMarker) {
        map.addSource("finish", {
          type: "geojson",
          data: {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: lastPoint,
            },
          },
        })
        map.addLayer({
          id: "finish",
          source: "finish",
          type: "symbol",
          layout: {
            "text-field": "Finish",
            ...textLayerStyles,
          },
        })
      }

      map.addLayer({
        id: "overlay",
        source: "overlay",
        type: "line",
        paint: {
          "line-width": 2.5,
          "line-color": "#F27968",
        },
        layout: {
          "line-cap": "round",
        },
      })

      const Pins = [firstPoint, lastPoint]
      Pins.forEach((point) => {
        const pinElementTemplate = document.createElement("template")
        pinElementTemplate.innerHTML = MapPinIconString.trim()
        const pinElement = pinElementTemplate.content.firstChild
        new mapboxgl.Marker({
          element: pinElement,
          offset: [0, -23.5],
        })
          .setLngLat(point)
          .addTo(map)
      })
    })
  }
  const { ref, generateStaticMap } = useMap({
    center: [Longitude, Latitude],
    zoom: Zoom,
    onInit,
  })
  return (
    <section>
      <Head>
        <link
          href="https://api.tiles.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.css"
          rel="stylesheet"
          key="mapbox-css"
        />
      </Head>
      <Container>
        <MapAContainer
          style={{
            backgroundImage: `url(${generateStaticMap({
              width: 1200,
              height: 544,
            })})`,
          }}
          ref={ref}
        />
      </Container>
    </section>
  )
}

export default MapC
